// App Scope:
// global functions for the whole accountant page
document.addEventListener('alpine:init', () => {
    window.Alpine.data('accountantApp', () => ({}));
})
